// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;500;600;700&family=Fira+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login Page Styles - Premium White & Vibrant Blue (V3) */

:root {
  --tesalut-blue: #3b82f6; /* Vibrant Blue */
  --tesalut-blue-hover: #2563eb;
  --tesalut-blue-soft: rgba(59, 130, 246, 0.1);
  --text-main: #0f172a;
  --text-muted: #64748b;
  --bg-card: rgba(255, 255, 255, 0.75);
  --border-light: rgba(0, 0, 0, 0.08);
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  padding: 20px;
  background: #f8fafc;
  font-family: 'Fira Sans', sans-serif;
}

.login-bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background: radial-gradient(circle at top right, #eff6ff 0%, #f1f5f9 100%);
}

.login-bg-blob {
  position: absolute;
  width: 700px;
  height: 700px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.12) 0%, rgba(37, 99, 235, 0.08) 100%);
  filter: blur(120px);
  border-radius: 50%;
  z-index: 1;
  animation: blobFloat 30s infinite alternate cubic-bezier(0.45, 0, 0.55, 1);
}

.blob-1 { top: -200px; right: -150px; }
.blob-2 { bottom: -200px; left: -150px; background: linear-gradient(135deg, rgba(96, 165, 250, 0.08) 0%, rgba(147, 197, 253, 0.05) 100%); animation-delay: -5s; }

@keyframes blobFloat {
  0% { transform: translate(0, 0) scale(1); rotate: 0deg; }
  50% { transform: translate(100px, -50px) scale(1.1); rotate: 180deg; }
  100% { transform: translate(0, 0) scale(1); rotate: 360deg; }
}

.login-form {
  position: relative;
  z-index: 10;
  background: var(--bg-card);
  backdrop-filter: blur(32px) saturate(200%);
  -webkit-backdrop-filter: blur(32px) saturate(200%);
  border: 1px solid rgba(255, 255, 255, 0.9);
  padding: 28px 40px;
  border-radius: 36px;
  box-shadow: 
    0 30px 60px -12px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.01);
  width: 100%;
  max-width: 460px;
  animation: loginAppear 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes loginAppear {
  from { opacity: 0; transform: translateY(30px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.login-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 28px;
  gap: 16px;
}

.login-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
}

.login-logo-svg {
  height: 50px;
  width: auto;
  max-width: min(220px, 100%);
  display: block;
  filter: drop-shadow(0 4px 14px rgba(253, 207, 8, 0.25));
}

.login-top-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.login-lang-slot {
  flex-shrink: 0;
  width: 85px;
  display: flex;
  align-items: center;
  align-self: center;
}

.login-theme-toggle {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition: color 0.25s ease, background 0.25s ease, border-color 0.25s ease;
}

.login-theme-toggle:hover {
  color: var(--tesalut-blue);
  background: #f8fafc;
  border-color: rgba(59, 130, 246, 0.3);
}

.login-title {
  font-family: 'Fira Sans', sans-serif;
  font-size: 1.6rem;
  font-weight: 800;
  color: #0f172a;
  text-align: center;
  margin-top: 0;
  margin-bottom: 36px;
  letter-spacing: -0.8px;
}

.form-group {
  margin-bottom: 16px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

.login-form .form-label {
  display: block;
  font-size: 0.6rem;
  font-weight: 700;
  color: var(--text-muted);
  margin-bottom: 6px;
  margin-left: 2px;
  padding-left: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: left;
}

.form-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

/* Только экран входа: глобальный .form-input с 60px слева !important иначе после логина ломает модалки с тем же классом */
.login-form .form-input {
  width: 100%;
  padding: 16px 16px 16px 60px !important; /* Combined and forced */
  border: 1px solid var(--border-light);
  background: rgba(255, 255, 255, 0.5);
  color: var(--text-main);
  font-family: 'Fira Sans', sans-serif;
  border-radius: 18px;
  font-size: 1.05rem;
  transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
  outline: none;
}

.login-form .form-input:focus {
  border-color: var(--tesalut-blue);
  background: #ffffff;
  box-shadow: 0 0 0 4px var(--tesalut-blue-soft);
}

.input-icon-wrapper {
  position: absolute;
  left: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  transition: all 0.3s ease;
  pointer-events: none;
}

.login-form .form-input:focus ~ .input-icon-wrapper {
  color: var(--tesalut-blue);
  transform: scale(1.1);
}

.submit-button {
  width: 100%;
  padding: 18px;
  background: var(--tesalut-blue); /* Vibrant Blue */
  color: #ffffff;
  border: none;
  border-radius: 20px;
  font-family: 'Fira Sans', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
  margin-top: 14px;
  box-shadow: 0 10px 25px -8px rgba(59, 130, 246, 0.3);
}

.submit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px -8px rgba(59, 130, 246, 0.4);
  background: var(--tesalut-blue-hover);
}

.submit-button:active {
  transform: translateY(1px);
}

/* Custom Boxed Dropdown — те же горизонтальные отступы, что у .form-input (иконка слева на 18px, текст с 60px) */
.custom-dropdown-container {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.custom-dropdown-trigger {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--border-light);
  background: rgba(255, 255, 255, 0.5);
  color: var(--text-main);
  border-radius: 18px;
  font-family: 'Fira Sans', sans-serif;
  font-size: 1.05rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.custom-dropdown-trigger:not(.lang-trigger) {
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px 44px 16px 60px;
  justify-content: flex-start;
}

.custom-dropdown-field-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  pointer-events: none;
  transition: color 0.3s ease, transform 0.3s ease;
}

.custom-dropdown-trigger:not(.lang-trigger) .trigger-text {
  flex: 1 1;
  min-width: 0;
  text-align: left;
}

.custom-dropdown-chevron-wrap {
  position: absolute;
  right: 18px;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  transition: transform 0.3s ease;
  pointer-events: none;
}

.custom-dropdown-chevron-wrap.is-open {
  transform: translateY(-50%) rotate(180deg);
}

.custom-dropdown-trigger:not(.lang-trigger).active .custom-dropdown-field-icon {
  color: var(--tesalut-blue);
  transform: translateY(-50%) scale(1.08);
}

.custom-dropdown-trigger.lang-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  font-size: 0.9rem;
  font-weight: 700;
  border-radius: 14px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.trigger-text {
  flex: 1 1;
}

.custom-dropdown-trigger:not(.lang-trigger):hover {
  background: #ffffff;
  border-color: rgba(0, 0, 0, 0.12);
}

.custom-dropdown-trigger:not(.lang-trigger).active {
  border-color: var(--tesalut-blue);
  background: #ffffff;
  box-shadow: 0 0 0 4px var(--tesalut-blue-soft);
}

.custom-dropdown-trigger.lang-trigger:hover {
  background: #ffffff;
  border-color: rgba(0, 0, 0, 0.12);
}

.custom-dropdown-menu {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 24px;
  z-index: 100;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.12);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px; /* Spacing between "boxes" */
  animation: dropdownPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes dropdownPop {
  from { opacity: 0; transform: scale(0.95) translateY(-10px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.dropdown-item {
  padding: 14px 18px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  color: #475569;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  background: #f8fafc; /* Box background */
  border: 1px solid transparent;
}

.dropdown-item:hover {
  background: #eff6ff;
  color: var(--tesalut-blue);
  border-color: rgba(59, 130, 246, 0.1);
  transform: translateX(4px);
}

.dropdown-item.active {
  background: var(--tesalut-blue);
  color: #fff;
  font-weight: 600;
  box-shadow: 0 8px 16px -4px rgba(59, 130, 246, 0.3);
}

.dropdown-item.text-center {
  justify-content: center;
  padding: 12px;
}

.dropdown-item.text-left {
  justify-content: flex-start;
}

.remember-row {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.remember-checkbox {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.remember-checkbox input {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  accent-color: var(--tesalut-blue);
}

.error-message {
  background: #fff1f2;
  color: #e11d48;
  padding: 14px;
  border-radius: 18px;
  font-size: 0.95rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 28px;
  border: 1px solid #ffe4e6;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.password-toggle {
  position: absolute;
  right: 18px;
  color: #94a3b8;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.3s ease;
  display: flex;
  padding: 6px;
}

.password-toggle:hover {
  color: var(--text-main);
}

@media (max-width: 480px) {
  .login-form {
    padding: 30px 20px;
  }
  .login-title {
    font-size: 1.5rem;
  }
}

/* ============================================================
   Тёмная тема экрана логина
   ============================================================ */
:root[data-theme='dark'] .login-container {
  background: #0b1120;
}

:root[data-theme='dark'] .login-bg-overlay {
  background: radial-gradient(circle at top right, #16233b 0%, #0b1120 100%);
}

:root[data-theme='dark'] .login-bg-blob {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(37, 99, 235, 0.10) 100%);
}

:root[data-theme='dark'] .blob-2 {
  background: linear-gradient(135deg, rgba(96, 165, 250, 0.12) 0%, rgba(147, 197, 253, 0.06) 100%);
}

:root[data-theme='dark'] .login-form {
  background: rgba(30, 41, 59, 0.72);
  border-color: rgba(148, 163, 184, 0.16);
  box-shadow:
    0 30px 60px -12px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.02);
}

:root[data-theme='dark'] .login-title {
  color: #f8fafc;
}

:root[data-theme='dark'] .form-label {
  color: #94a3b8;
}

:root[data-theme='dark'] .login-form .form-input {
  background: rgba(15, 23, 42, 0.6);
  border-color: rgba(148, 163, 184, 0.18);
  color: #f1f5f9;
}

:root[data-theme='dark'] .login-form .form-input:focus {
  background: rgba(15, 23, 42, 0.9);
  border-color: var(--tesalut-blue);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.18);
}

:root[data-theme='dark'] .input-icon-wrapper,
:root[data-theme='dark'] .password-toggle,
:root[data-theme='dark'] .custom-dropdown-field-icon {
  color: #64748b;
}

:root[data-theme='dark'] .password-toggle:hover {
  color: #f1f5f9;
}

/* Переключатель темы */
:root[data-theme='dark'] .login-theme-toggle {
  background: rgba(15, 23, 42, 0.6);
  border-color: rgba(148, 163, 184, 0.18);
  color: #cbd5e1;
}

:root[data-theme='dark'] .login-theme-toggle:hover {
  background: rgba(15, 23, 42, 0.9);
  color: #93c5fd;
  border-color: rgba(59, 130, 246, 0.4);
}

/* Языковой дропдаун */
:root[data-theme='dark'] .custom-dropdown-trigger,
:root[data-theme='dark'] .custom-dropdown-trigger.lang-trigger {
  background: rgba(15, 23, 42, 0.6);
  border-color: rgba(148, 163, 184, 0.18);
  color: #f1f5f9;
}

:root[data-theme='dark'] .custom-dropdown-trigger:not(.lang-trigger):hover,
:root[data-theme='dark'] .custom-dropdown-trigger.lang-trigger:hover {
  background: rgba(15, 23, 42, 0.9);
  border-color: rgba(148, 163, 184, 0.3);
}

:root[data-theme='dark'] .custom-dropdown-trigger:not(.lang-trigger).active {
  border-color: var(--tesalut-blue);
  background: rgba(15, 23, 42, 0.9);
}

:root[data-theme='dark'] .custom-dropdown-menu {
  background: rgba(15, 23, 42, 0.92);
  border-color: rgba(148, 163, 184, 0.14);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);
}

:root[data-theme='dark'] .dropdown-item {
  background: rgba(30, 41, 59, 0.7);
  color: #cbd5e1;
}

:root[data-theme='dark'] .dropdown-item:hover {
  background: rgba(59, 130, 246, 0.16);
  color: #93c5fd;
  border-color: rgba(59, 130, 246, 0.25);
}

:root[data-theme='dark'] .dropdown-item.active {
  background: var(--tesalut-blue);
  color: #ffffff;
}

:root[data-theme='dark'] .remember-checkbox {
  color: #94a3b8;
}

:root[data-theme='dark'] .error-message {
  background: rgba(190, 18, 60, 0.14);
  color: #fda4af;
  border-color: rgba(244, 63, 94, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/css/login.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAG1D;EACE,uBAAuB,EAAE,iBAAiB;EAC1C,6BAA6B;EAC7B,4CAA4C;EAC5C,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,8FAA8F;EAC9F,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,0EAA0E;AAC5E;;AAEA,UAAU,WAAW,EAAE,aAAa,EAAE;AACtC,UAAU,cAAc,EAAE,YAAY,EAAE,gGAAgG,EAAE,oBAAoB,EAAE;;AAEhK;EACE,KAAK,mCAAmC,EAAE,YAAY,EAAE;EACxD,MAAM,6CAA6C,EAAE,cAAc,EAAE;EACrE,OAAO,mCAAmC,EAAE,cAAc,EAAE;AAC9D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB;;iCAE+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,0HAA0H;AAC1H;EACE,WAAW;EACX,uCAAuC,EAAE,wBAAwB;EACjE,qCAAqC;EACrC,oCAAoC;EACpC,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;EACnD,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B,EAAE,iBAAiB;EAClD,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;EACnD,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;EACpD,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iHAAiH;AACjH;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,qCAAqC;EACrC,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,iDAAiD;EACjD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,4BAA4B;EACtC,6DAA6D;AAC/D;;AAEA;EACE,OAAO,UAAU,EAAE,wCAAwC,EAAE;EAC7D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iDAAiD;EACjD,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE,mBAAmB;EACxC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;;iEAEiE;AACjE;EACE,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,gGAAgG;AAClG;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC;;uCAEqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,oCAAoC;AACtC","sourcesContent":["/* Login Page Styles - Premium White & Vibrant Blue (V3) */\n@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;500;600;700&family=Fira+Sans:wght@300;400;500;600;700&display=swap');\n\n:root {\n  --tesalut-blue: #3b82f6; /* Vibrant Blue */\n  --tesalut-blue-hover: #2563eb;\n  --tesalut-blue-soft: rgba(59, 130, 246, 0.1);\n  --text-main: #0f172a;\n  --text-muted: #64748b;\n  --bg-card: rgba(255, 255, 255, 0.75);\n  --border-light: rgba(0, 0, 0, 0.08);\n}\n\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  padding: 20px;\n  background: #f8fafc;\n  font-family: 'Fira Sans', sans-serif;\n}\n\n.login-bg-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  background: radial-gradient(circle at top right, #eff6ff 0%, #f1f5f9 100%);\n}\n\n.login-bg-blob {\n  position: absolute;\n  width: 700px;\n  height: 700px;\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.12) 0%, rgba(37, 99, 235, 0.08) 100%);\n  filter: blur(120px);\n  border-radius: 50%;\n  z-index: 1;\n  animation: blobFloat 30s infinite alternate cubic-bezier(0.45, 0, 0.55, 1);\n}\n\n.blob-1 { top: -200px; right: -150px; }\n.blob-2 { bottom: -200px; left: -150px; background: linear-gradient(135deg, rgba(96, 165, 250, 0.08) 0%, rgba(147, 197, 253, 0.05) 100%); animation-delay: -5s; }\n\n@keyframes blobFloat {\n  0% { transform: translate(0, 0) scale(1); rotate: 0deg; }\n  50% { transform: translate(100px, -50px) scale(1.1); rotate: 180deg; }\n  100% { transform: translate(0, 0) scale(1); rotate: 360deg; }\n}\n\n.login-form {\n  position: relative;\n  z-index: 10;\n  background: var(--bg-card);\n  backdrop-filter: blur(32px) saturate(200%);\n  -webkit-backdrop-filter: blur(32px) saturate(200%);\n  border: 1px solid rgba(255, 255, 255, 0.9);\n  padding: 28px 40px;\n  border-radius: 36px;\n  box-shadow: \n    0 30px 60px -12px rgba(0, 0, 0, 0.08),\n    0 0 0 1px rgba(0, 0, 0, 0.01);\n  width: 100%;\n  max-width: 460px;\n  animation: loginAppear 0.8s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes loginAppear {\n  from { opacity: 0; transform: translateY(30px) scale(0.97); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.login-top {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 28px;\n  gap: 16px;\n}\n\n.login-brand {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  min-width: 0;\n}\n\n.login-logo-svg {\n  height: 50px;\n  width: auto;\n  max-width: min(220px, 100%);\n  display: block;\n  filter: drop-shadow(0 4px 14px rgba(253, 207, 8, 0.25));\n}\n\n.login-top-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.login-lang-slot {\n  flex-shrink: 0;\n  width: 85px;\n  display: flex;\n  align-items: center;\n  align-self: center;\n}\n\n.login-theme-toggle {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  background: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  transition: color 0.25s ease, background 0.25s ease, border-color 0.25s ease;\n}\n\n.login-theme-toggle:hover {\n  color: var(--tesalut-blue);\n  background: #f8fafc;\n  border-color: rgba(59, 130, 246, 0.3);\n}\n\n.login-title {\n  font-family: 'Fira Sans', sans-serif;\n  font-size: 1.6rem;\n  font-weight: 800;\n  color: #0f172a;\n  text-align: center;\n  margin-top: 0;\n  margin-bottom: 36px;\n  letter-spacing: -0.8px;\n}\n\n.form-group {\n  margin-bottom: 16px;\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.login-form .form-label {\n  display: block;\n  font-size: 0.6rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  margin-bottom: 6px;\n  margin-left: 2px;\n  padding-left: 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  text-align: left;\n}\n\n.form-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n/* Только экран входа: глобальный .form-input с 60px слева !important иначе после логина ломает модалки с тем же классом */\n.login-form .form-input {\n  width: 100%;\n  padding: 16px 16px 16px 60px !important; /* Combined and forced */\n  border: 1px solid var(--border-light);\n  background: rgba(255, 255, 255, 0.5);\n  color: var(--text-main);\n  font-family: 'Fira Sans', sans-serif;\n  border-radius: 18px;\n  font-size: 1.05rem;\n  transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);\n  outline: none;\n}\n\n.login-form .form-input:focus {\n  border-color: var(--tesalut-blue);\n  background: #ffffff;\n  box-shadow: 0 0 0 4px var(--tesalut-blue-soft);\n}\n\n.input-icon-wrapper {\n  position: absolute;\n  left: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n  transition: all 0.3s ease;\n  pointer-events: none;\n}\n\n.login-form .form-input:focus ~ .input-icon-wrapper {\n  color: var(--tesalut-blue);\n  transform: scale(1.1);\n}\n\n.submit-button {\n  width: 100%;\n  padding: 18px;\n  background: var(--tesalut-blue); /* Vibrant Blue */\n  color: #ffffff;\n  border: none;\n  border-radius: 20px;\n  font-family: 'Fira Sans', sans-serif;\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);\n  margin-top: 14px;\n  box-shadow: 0 10px 25px -8px rgba(59, 130, 246, 0.3);\n}\n\n.submit-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 15px 30px -8px rgba(59, 130, 246, 0.4);\n  background: var(--tesalut-blue-hover);\n}\n\n.submit-button:active {\n  transform: translateY(1px);\n}\n\n/* Custom Boxed Dropdown — те же горизонтальные отступы, что у .form-input (иконка слева на 18px, текст с 60px) */\n.custom-dropdown-container {\n  position: relative;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.custom-dropdown-trigger {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--border-light);\n  background: rgba(255, 255, 255, 0.5);\n  color: var(--text-main);\n  border-radius: 18px;\n  font-family: 'Fira Sans', sans-serif;\n  font-size: 1.05rem;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.custom-dropdown-trigger:not(.lang-trigger) {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 16px 44px 16px 60px;\n  justify-content: flex-start;\n}\n\n.custom-dropdown-field-icon {\n  position: absolute;\n  left: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n  pointer-events: none;\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n.custom-dropdown-trigger:not(.lang-trigger) .trigger-text {\n  flex: 1;\n  min-width: 0;\n  text-align: left;\n}\n\n.custom-dropdown-chevron-wrap {\n  position: absolute;\n  right: 18px;\n  top: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(-50%);\n  transition: transform 0.3s ease;\n  pointer-events: none;\n}\n\n.custom-dropdown-chevron-wrap.is-open {\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.custom-dropdown-trigger:not(.lang-trigger).active .custom-dropdown-field-icon {\n  color: var(--tesalut-blue);\n  transform: translateY(-50%) scale(1.08);\n}\n\n.custom-dropdown-trigger.lang-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  font-size: 0.9rem;\n  font-weight: 700;\n  border-radius: 14px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.trigger-text {\n  flex: 1;\n}\n\n.custom-dropdown-trigger:not(.lang-trigger):hover {\n  background: #ffffff;\n  border-color: rgba(0, 0, 0, 0.12);\n}\n\n.custom-dropdown-trigger:not(.lang-trigger).active {\n  border-color: var(--tesalut-blue);\n  background: #ffffff;\n  box-shadow: 0 0 0 4px var(--tesalut-blue-soft);\n}\n\n.custom-dropdown-trigger.lang-trigger:hover {\n  background: #ffffff;\n  border-color: rgba(0, 0, 0, 0.12);\n}\n\n.custom-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 12px);\n  left: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  border-radius: 24px;\n  z-index: 100;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.12);\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px; /* Spacing between \"boxes\" */\n  animation: dropdownPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes dropdownPop {\n  from { opacity: 0; transform: scale(0.95) translateY(-10px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.dropdown-item {\n  padding: 14px 18px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  color: #475569;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  background: #f8fafc; /* Box background */\n  border: 1px solid transparent;\n}\n\n.dropdown-item:hover {\n  background: #eff6ff;\n  color: var(--tesalut-blue);\n  border-color: rgba(59, 130, 246, 0.1);\n  transform: translateX(4px);\n}\n\n.dropdown-item.active {\n  background: var(--tesalut-blue);\n  color: #fff;\n  font-weight: 600;\n  box-shadow: 0 8px 16px -4px rgba(59, 130, 246, 0.3);\n}\n\n.dropdown-item.text-center {\n  justify-content: center;\n  padding: 12px;\n}\n\n.dropdown-item.text-left {\n  justify-content: flex-start;\n}\n\n.remember-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.remember-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  user-select: none;\n}\n\n.remember-checkbox input {\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  accent-color: var(--tesalut-blue);\n}\n\n.error-message {\n  background: #fff1f2;\n  color: #e11d48;\n  padding: 14px;\n  border-radius: 18px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 28px;\n  border: 1px solid #ffe4e6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 18px;\n  color: #94a3b8;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: color 0.3s ease;\n  display: flex;\n  padding: 6px;\n}\n\n.password-toggle:hover {\n  color: var(--text-main);\n}\n\n@media (max-width: 480px) {\n  .login-form {\n    padding: 30px 20px;\n  }\n  .login-title {\n    font-size: 1.5rem;\n  }\n}\n\n/* ============================================================\n   Тёмная тема экрана логина\n   ============================================================ */\n:root[data-theme='dark'] .login-container {\n  background: #0b1120;\n}\n\n:root[data-theme='dark'] .login-bg-overlay {\n  background: radial-gradient(circle at top right, #16233b 0%, #0b1120 100%);\n}\n\n:root[data-theme='dark'] .login-bg-blob {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(37, 99, 235, 0.10) 100%);\n}\n\n:root[data-theme='dark'] .blob-2 {\n  background: linear-gradient(135deg, rgba(96, 165, 250, 0.12) 0%, rgba(147, 197, 253, 0.06) 100%);\n}\n\n:root[data-theme='dark'] .login-form {\n  background: rgba(30, 41, 59, 0.72);\n  border-color: rgba(148, 163, 184, 0.16);\n  box-shadow:\n    0 30px 60px -12px rgba(0, 0, 0, 0.5),\n    0 0 0 1px rgba(255, 255, 255, 0.02);\n}\n\n:root[data-theme='dark'] .login-title {\n  color: #f8fafc;\n}\n\n:root[data-theme='dark'] .form-label {\n  color: #94a3b8;\n}\n\n:root[data-theme='dark'] .login-form .form-input {\n  background: rgba(15, 23, 42, 0.6);\n  border-color: rgba(148, 163, 184, 0.18);\n  color: #f1f5f9;\n}\n\n:root[data-theme='dark'] .login-form .form-input:focus {\n  background: rgba(15, 23, 42, 0.9);\n  border-color: var(--tesalut-blue);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.18);\n}\n\n:root[data-theme='dark'] .input-icon-wrapper,\n:root[data-theme='dark'] .password-toggle,\n:root[data-theme='dark'] .custom-dropdown-field-icon {\n  color: #64748b;\n}\n\n:root[data-theme='dark'] .password-toggle:hover {\n  color: #f1f5f9;\n}\n\n/* Переключатель темы */\n:root[data-theme='dark'] .login-theme-toggle {\n  background: rgba(15, 23, 42, 0.6);\n  border-color: rgba(148, 163, 184, 0.18);\n  color: #cbd5e1;\n}\n\n:root[data-theme='dark'] .login-theme-toggle:hover {\n  background: rgba(15, 23, 42, 0.9);\n  color: #93c5fd;\n  border-color: rgba(59, 130, 246, 0.4);\n}\n\n/* Языковой дропдаун */\n:root[data-theme='dark'] .custom-dropdown-trigger,\n:root[data-theme='dark'] .custom-dropdown-trigger.lang-trigger {\n  background: rgba(15, 23, 42, 0.6);\n  border-color: rgba(148, 163, 184, 0.18);\n  color: #f1f5f9;\n}\n\n:root[data-theme='dark'] .custom-dropdown-trigger:not(.lang-trigger):hover,\n:root[data-theme='dark'] .custom-dropdown-trigger.lang-trigger:hover {\n  background: rgba(15, 23, 42, 0.9);\n  border-color: rgba(148, 163, 184, 0.3);\n}\n\n:root[data-theme='dark'] .custom-dropdown-trigger:not(.lang-trigger).active {\n  border-color: var(--tesalut-blue);\n  background: rgba(15, 23, 42, 0.9);\n}\n\n:root[data-theme='dark'] .custom-dropdown-menu {\n  background: rgba(15, 23, 42, 0.92);\n  border-color: rgba(148, 163, 184, 0.14);\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);\n}\n\n:root[data-theme='dark'] .dropdown-item {\n  background: rgba(30, 41, 59, 0.7);\n  color: #cbd5e1;\n}\n\n:root[data-theme='dark'] .dropdown-item:hover {\n  background: rgba(59, 130, 246, 0.16);\n  color: #93c5fd;\n  border-color: rgba(59, 130, 246, 0.25);\n}\n\n:root[data-theme='dark'] .dropdown-item.active {\n  background: var(--tesalut-blue);\n  color: #ffffff;\n}\n\n:root[data-theme='dark'] .remember-checkbox {\n  color: #94a3b8;\n}\n\n:root[data-theme='dark'] .error-message {\n  background: rgba(190, 18, 60, 0.14);\n  color: #fda4af;\n  border-color: rgba(244, 63, 94, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
